export default "__VITE_ASSET__4568f720__"